<div class="c-bui-drag-handle"
  [ngClass]="[
    'u-icon-color-' + (iconColor | toCssClassName),
    isDisabled ? 'u-disabled' : ''
  ]">
  <div class="c-bui-drag-handle__icon"
    [ngClass]="[
      iconSize ? 'c-bui-drag-handle__icon--size-' + (iconSize | toCssClassName) : ''
    ]">
    <app-bui-icon
      [type]="iconType"
      [name]="'drag_indicator'"
      [inline]="true">
    </app-bui-icon>
  </div>
</div>
